import { asyncActionCreator } from '../../../utils/generalUtilities';

export const GET_TOOLBOX_URL = 'pages/landing/GET_TOOLBOX_URL';
export const GET_TOOLBOX_URL_ASYNC = asyncActionCreator('pages/landing/GET_TOOLBOX_URL_ASYNC');

export const getToolboxUrlActionCreator = id => ({
    type: GET_TOOLBOX_URL,
    payload: id,
});
